import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    pure: true,
})
export class FileSizePipe implements PipeTransform {
  transform(bytes: number): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const megabytePow = 2;
    const inputPow = Math.floor(Math.log(bytes) / Math.log(1024));

    const pow = Math.max(inputPow, megabytePow);

    return `${parseFloat((bytes / Math.pow(1024, pow)).toFixed(2))} ${
      sizes[pow]
    }`.replace('.', ',');
  }
}
